import { createApp } from 'vue'
import App from './App.vue'
import store from '@/x/store'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import DebugPlugin from '@/x/plugins/debug'
import ComponentsPlugin from '@/x/plugins/components'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import watermark from '@/libs/watermark'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// vant 使用api 需要另外引入样式
// Toast
import "vant/es/toast/style";
// Dialog
import "vant/es/dialog/style";
// Notify
import "vant/es/notify/style";
// ImagePreview
import "vant/es/image-preview/style";

app.use(ComponentsPlugin)
app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(DebugPlugin)
app.use(watermark)
app.mount('#app')
